import i18n from '../../language/index'
const combAnimationList = [
  {
    id: 0,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2249'),
    formData: {
      _key: 'none'
    }
  },
  {
    id: 1,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2250'),
    formData: {
      direction: 'default',
      trigger: 0,
      _key: 'fadeIn'
    },
    direction: {
      default: 'view_back_top_edit_103',
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: [i18n.t('components_my_animation_comb_animation_list_2251'), i18n.t('components_my_animation_comb_animation_list_2252')]
  },
  {
    id: 2,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2253'),
    formData: {
      direction: 'left',
      trigger: 0,
      _key: 'moveIn'
    },
    direction: {
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: [i18n.t('components_my_animation_comb_animation_list_2251'), i18n.t('components_my_animation_comb_animation_list_2252')]
  },
  {
    id: 3,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2254'),
    formData: {
      direction: 'default',
      trigger: 0,
      _key: 'zoomIn'
    },
    direction: {
      default: 'view_back_top_edit_103',
      left: 'base_options_config_1822',
      right: 'base_options_config_1823',
      top: 'base_options_config_1824',
      bottom: 'base_options_config_1825'
    },
    trigger: [i18n.t('components_my_animation_comb_animation_list_2251'), i18n.t('components_my_animation_comb_animation_list_2252')]
  },
  {
    id: 4,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2255'),
    formData: {
      trigger: 0,
      _key: 'elasticLarge'
    },
    trigger: [i18n.t('components_my_animation_comb_animation_list_2251'), i18n.t('components_my_animation_comb_animation_list_2252')]
  },
  {
    id: 5,
    typeTitle: i18n.t('components_my_animation_comb_animation_list_2256'),
    formData: {
      trigger: 0,
      _key: 'elasticSmall'
    },
    trigger: [i18n.t('components_my_animation_comb_animation_list_2251'), i18n.t('components_my_animation_comb_animation_list_2252')]
  }
]

export default combAnimationList



// WEBPACK FOOTER //
// ./src/components/my_animation/comb_animation_list.js